import { environment } from '../../environments/environment';

/**
 * Returns the configured display name for an AOX server without changing the
 * URL that is retained in upload state and used for requests.
 */
export const getServerDisplayName = (server: unknown): unknown => {
  if (typeof server !== 'string') {
    return server;
  }

  const serverMap = environment.appDesignSettings?.appParameters?.serverMap;
  const displayName = serverMap?.[server];
  return typeof displayName === 'string' && displayName.trim() !== '' ? displayName : server;
};
